export default "__VITE_ASSET__ng1dmLFM__"